module.exports = __webpack_public_path__ + "img/Amex.6d5d5311.svg";